export default function ChristmasPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative h-96 bg-gradient-to-br from-red-600 to-green-700 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1512389142860-9c449e58a543?w=1200&h=600&fit=crop"
          alt="Christmas celebration"
          className="absolute inset-0 w-full h-full object-cover mix-blend-overlay opacity-40"
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-center">
          <h1 className="text-5xl font-bold text-white mb-4">Christmas Secret Santa</h1>
          <p className="text-xl text-white max-w-2xl">
            Spread holiday cheer with a festive gift exchange that brings your group together
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8 mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Perfect for Christmas Celebrations</h2>
          <p className="text-lg text-gray-600 mb-6">
            Christmas Secret Santa exchanges create magical moments of surprise and generosity during the most
            wonderful time of the year. Whether it's with family, coworkers, or friends, SwapGifts makes organizing
            your holiday exchange effortless.
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">Who it's for</h3>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li>• Family gatherings and reunions</li>
                <li>• Office holiday parties</li>
                <li>• Friend groups and social clubs</li>
                <li>• Church or community organizations</li>
                <li>• Virtual celebrations across distances</li>
              </ul>
            </div>

            <div className="border border-gray-200 rounded-lg p-5">
              <h3 className="font-semibold text-gray-900 mb-2">Typical budget range</h3>
              <p className="text-gray-600 text-sm mb-3">
                Most Christmas exchanges range from $25 to $100 depending on your group size and preferences.
              </p>
              <p className="text-gray-600 text-sm">
                SwapGifts supports all currencies and helps participants stay within budget with curated gift suggestions.
              </p>
            </div>
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-4">How to Organize Your Christmas Exchange</h3>
          <div className="space-y-4 mb-8">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-bold mr-4">
                1
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Set your date</h4>
                <p className="text-gray-600 text-sm">
                  Plan your exchange 2-3 weeks before Christmas Day to give everyone time to shop and ship gifts.
                  Popular dates are mid-December office parties or Christmas Eve family gatherings.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-bold mr-4">
                2
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Add your participants</h4>
                <p className="text-gray-600 text-sm">
                  Enter names and optional emails. For families, include everyone from kids to grandparents. For offices,
                  coordinate with HR to ensure no one is left out.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-bold mr-4">
                3
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Set exclusions if needed</h4>
                <p className="text-gray-600 text-sm">
                  Prevent couples from drawing each other, exclude parent-child pairs, or avoid repeating last year's matches.
                  Our algorithm handles complex rules automatically.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-bold mr-4">
                4
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Draw names and notify</h4>
                <p className="text-gray-600 text-sm">
                  Once everyone joins, execute the draw. Each participant gets their match privately. They can create wishlists
                  and browse gift ideas in our curated marketplace.
                </p>
              </div>
            </div>
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-4">Tips for a Successful Christmas Exchange</h3>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">•</span>
                <span>Set a clear budget and enforce it to keep things fair for everyone</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">•</span>
                <span>Encourage participants to create detailed wishlists with specific preferences</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">•</span>
                <span>Account for shipping time if participants are in different locations</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">•</span>
                <span>Consider themes like "homemade gifts" or "books only" for creative twists</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">•</span>
                <span>Plan a reveal moment during your gathering for extra excitement</span>
              </li>
            </ul>
          </div>

          <div className="text-center">
            <a
              href="/create"
              className="inline-block px-8 py-4 bg-green-600 text-white text-lg font-semibold rounded-lg hover:bg-green-700 transition-colors"
            >
              Start Your Christmas Exchange
            </a>
            <p className="text-sm text-gray-500 mt-3">No registration required • Free to use</p>
          </div>
        </div>

        <div className="bg-gray-100 rounded-lg p-6">
          <h3 className="font-semibold text-gray-900 mb-3">Related Resources</h3>
          <div className="flex flex-wrap gap-3">
            <a href="/events/office-party" className="text-sm text-gray-700 hover:text-green-600">
              Office Party Exchanges →
            </a>
            <a href="/blog" className="text-sm text-gray-700 hover:text-green-600">
              Gift Ideas Blog →
            </a>
            <a href="/how-it-works" className="text-sm text-gray-700 hover:text-green-600">
              How It Works →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
